import r from"react";import{DayPicker as o}from"react-day-picker";var p=e=>r.createElement(o,{mode:"range",weekStartsOn:1,...e});export{p as a};
